import {ApiIndex} from "../../../api/api";

export default {
  namespaced: true,
  state: {
    tabName : "",
    site : {},
    layout : ""
  },

  mutations:{
    /**
     * 设备tab名称
     * @param state
     * @param name
     */
    setTabName (state, name) {

      state.tabName = name;
    },

    /**
     * 设备tab名称
     * @param state
     * @param name
     */
    setLayout (state, name) {
      state.layout = name;
      localStorage.setItem("layout",name);
    },

    /**
     * @class pool
     * @param {Object} state vuex state
     * @param {Array} routes routes
     */
    init (state,that) {
      ApiIndex().then(res=>{
        if(res.code == 200) {
          state.site = res.data;
          that.$bus.$emit('pageInit',res.data);
        }
      });
      let latyou = localStorage.getItem("layout") || "public";
      state.layout = latyou;
    },
  },
  actions: {

    /**
     * 个人设置
     * @param commit
     * @param dispatch
     */
    userInit({commit,dispatch}) {
    },


  }
}



// WEBPACK FOOTER //
// ./src/store/home/modules/page.js